import { config } from "../config/config";
import { getAuthToken } from "./tokenService.service";

export const outboundService = {
  getOutboundsByService: async (
    startDate: string,
    endDate: string,
    branch_id: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/outbounds/by-service`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ startDate, endDate, branch_id }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch outbounds by service");
    }

    const json = await response.json();
    return json.data;
  },

  getOutboundsByDestinationDomestic: async (
    startDate: string,
    endDate: string,
    branch_id: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/outbounds/by-destination-domestic`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ startDate, endDate, branch_id }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch outbounds by destination (domestic)");
    }

    const json = await response.json();
    return json.data;
  },

  getOutboundsByDestinationIntracity: async (
    startDate: string,
    endDate: string,
    branch_id: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(
      `${config.baseURL}/outbounds/by-destination-intracity`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ startDate, endDate, branch_id }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch outbounds by destination (intracity)");
    }

    const json = await response.json();
    return json.data;
  },

  getPetaOutbound: async (
    startDate: string,
    endDate: string,
    branch_id: string
  ) => {
    const token = getAuthToken();

    const response = await fetch(`${config.baseURL}/outbounds/peta-outbound`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ startDate, endDate, branch_id }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch peta outbounds");
    }

    const json = await response.json();
    return json.data;
  },
};
